import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'residential-solar-panel-installation-sydney';
const serviceId = 1
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: `Residential Solar Panel Installation Sydney | ${BUSINESS_NAME}`,
        description: "Tailored solar systems for homes to cut energy bills. Our expert installers design systems to suit your roof, lifestyle, and long-term energy needs.",
        keywords: "residential solar panel installation Sydney, home solar systems, solar energy solutions, solar panel installers, energy-efficient homes, solar power for residences, custom solar designs, solar maintenance services, renewable energy Sydney, sustainable living solutions",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Residential Solar Panel Installation',
    description: 'Tailored solar systems for homes to cut energy bills. Our expert installers design systems to suit your roof, lifestyle, and long-term energy needs.',
    points: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
